module.exports = __webpack_public_path__ + "static/img/HY-S1-II.ad72e4a5.png";